// extracted by mini-css-extract-plugin
export default {"box":"FileUploader_box__rjSdQ","boxError":"FileUploader_boxError__Zh5oJ FileUploader_box__rjSdQ","progress":"FileUploader_progress__p+zM4"};